import React from 'react'

import clsx from 'clsx'

import BaseButton from '../BaseButton'

import classes from './IconButton.module.scss'

/** @type {import("./types").default} */
const IconButton = ({ className, children, size = 'medium', disabled, ...props }) => {
  return (
    <BaseButton
      className={clsx('IconButton', classes.root, classes[size], disabled && classes.disabled, className)}
      disabled={disabled}
      {...props}
    >
      {children}
    </BaseButton>
  )
}

export default IconButton
